import axios from 'axios';
import { toast } from 'react-toastify';

const isNetworkError = (error) => {
  if (!error) return false;
  const code = error.code;
  const msg = error.message || '';
  return (
    code === 'ERR_NETWORK' ||
    code === 'ECONNREFUSED' ||
    code === 'ECONNABORTED' ||
    code === 'ETIMEDOUT' ||
    msg.includes('Network Error') ||
    msg.includes('Failed to fetch')
  );
};

// In development, use proxy (avoids CORS) - requests go to same origin, proxy forwards to API

const getBaseURL = () => {
  const application_mode = process.env.REACT_APP_APPLICATION_MODE;

  if (application_mode === 'development') {
    return process.env.REACT_APP_DEVELOPMENT_BASE_API_URL;
  }

  return process.env.REACT_APP_PRODUCTION_BASE_API_URL;
};

export const getApiBaseUrl = () => getBaseURL();

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 30000, // 30 seconds - increased for slow connections
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isNetworkError(error)) {
      const message =
        'Cannot connect to server. Please check your internet connection and ensure the API server is running.';
      error.apiMessage = message;
      toast.error(message, { autoClose: 5000 });
    } else if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
